import { Formik } from "formik";
import { sendMessageSchema } from "../../utils/schema";
import ErrorMessage from "../form/ErrorMessage";

const SendMessageModal = ({ onClose, hendleSendMessage }) => {
  const initialState = {
    text: "",
  };

  return (
    <div className="modal d-block ct_congratulation_modal_fade" tabIndex="-1">
      <div
        class="modal-dialog modal-dialog-centered ct_modal-dialog"
        style={{ maxWidth: "700px" }}
      >
        <div class="modal-content ct_p_30 ct_border_radius_20">
          <div class="modal-header border-0 p-0 ct_mb_30">
            <div>
              <h4 class="mb-1 ct_fs_20">Send Message</h4>
              {/* <p class="mb-0 ct_grey_text">
                                Submit completed work or progress files for the client to
                                review
                            </p> */}
            </div>
            <button
              type="button"
              class="btn-close ct_circle_close"
              onClick={onClose}
            ></button>
          </div>
          <div class="modal-body p-0">
            <Formik
              initialValues={initialState}
              validationSchema={sendMessageSchema}
              onSubmit={(values, actions) => {
                hendleSendMessage(values?.text);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setTouched,
                setFieldValue,
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-12">
                      <div class="form-group ct_mb_20">
                        <label class="ct_fs_14 ct_darkblue_text mb-2">
                          Message
                        </label>
                        <textarea
                          value={values?.text}
                          id="text"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          class="form-control ct_input h-auto ct_fs_12"
                          rows={4}
                          placeholder="Write your message here...."
                        ></textarea>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="text"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-3 justify-content-end ">
                    <button
                      class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44"
                      type="button"
                      onClick={onClose}
                    >
                      Cancel
                    </button>
                    <button
                      class="ct_yellow_btn px-5 ct_h_44"
                      type="button"
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendMessageModal;
